export function navigateToSportBetsUrl(path: string) {
    if (path.indexOf("/") === 0) {
        path = `/kurzove-sazky${path}`;
    }

    if ((window as any).openSportApi?.navigateTo === undefined) {
        console.error("OpenSportApi function nagivateTo is not defined");
        window.location.href = path;
        return;
    }

    (window as any).openSportApi.navigateTo({ urlPath: path });
}
